import { types } from 'mobx-state-tree';

const DataDictionaryModel = types.model("DataDictionaryModel", {
  publicName: types.optional(types.string, ""),
  dataCode: types.optional(types.string, "")
});

export default DataDictionaryModel;
